export default __webpack_public_path__ + "static/media/267.fff42d29.jpg";